import { CHANNELS } from "../../shared/channels";
import { Goal, goalReadout, goalShare } from "../../shared/goals";
import { call, listen } from "../bridge";
import { t } from "../i18n";
import { canUse } from "../me";
import { showView } from "../navigation";

// a small goals card for home or anywhere else: the open goals with their bars, tap one to go to goals.
// the home layout decides where it sits, this only fills the box it's given and keeps it live

function goalRow(goal: Goal): HTMLElement {
  const row = document.createElement("li");
  row.className = `goal-mini sticky-${goal.colour}`;
  row.style.setProperty("--fill", String(goalShare(goal)));
  const title = document.createElement("span");
  title.className = "goal-mini-title";
  title.textContent = goal.title;
  const readout = document.createElement("span");
  readout.className = "goal-mini-readout";
  readout.textContent = goalReadout(goal);
  const bar = document.createElement("span");
  bar.className = "goal-bar";
  bar.append(Object.assign(document.createElement("span"), { className: "goal-fill" }));
  row.append(title, readout, bar);
  row.addEventListener("click", () => showView("goals"));
  return row;
}

// fills box with up to `limit` open goals, furthest along first. returns a refresh, and refreshes itself on changes
export function mountGoalsTile(box: HTMLElement, limit: number | (() => number) = 4): () => Promise<void> {
  const list = document.createElement("ul");
  list.className = "goal-minis";
  const empty = document.createElement("p");
  empty.className = "empty";
  empty.textContent = t("no goals on the go");
  box.replaceChildren(list, empty);

  const refresh = async (): Promise<void> => {
    if (!canUse("goals", "edit")) {
      box.hidden = true;
      return;
    }
    const goals = await call<Goal[]>(CHANNELS.goalsList).catch(() => [] as Goal[]);
    const open = goals.filter((goal) => !goal.done).sort((first, second) => goalShare(second) - goalShare(first)).slice(0, typeof limit === "function" ? limit() : limit);
    list.replaceChildren(...open.map(goalRow));
    empty.hidden = open.length > 0;
  };
  listen(CHANNELS.goalsUpdated, () => {
    if (box.isConnected) void refresh();
  });
  void refresh();
  return refresh;
}
